export const GuestBrandedDefaultColors = Object.freeze({
    background: '#F7F7F7',
    text: '#1C1F25',
    textHover: '#8C8F95',
    action: '#723D9E',
    actionText: '#FFFFFF',
    actionHover: '#7A49A4',
    actionActive: '#885fB0',
    border: '#B7B7B9',
});

export const GuestBrandedDefaultFonts = Object.freeze({
    body: 'Lato, sans-serif',
    heading: 'Lato, sans-serif',
    subHeading: 'Lato, sans-serif',
    button: 'Lato, sans-serif',
});
